/* tslint:disable */
/* eslint-disable */
/**
 * Speechmatics ASR REST API
 * The Speechmatics Automatic Speech Recognition REST API is used to submit ASR jobs and receive the results. The supported job type is transcription of audio files.
 *
 * The version of the OpenAPI document: 2.0.0
 * Contact: support@speechmatics.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

// May contain unused imports in some cases
// @ts-ignore
import type { RecognitionAlternative } from './recognition-alternative';

/**
 * A SpokenFormRecognitionResult describes a simple object which consists solely of \'word\' or \'punctuation\' type entries with a start and end time. It can occur only inside the spoken_form property of a full \'RecognitionResult\'
 * @export
 * @interface SpokenFormRecognitionResult
 */
export interface SpokenFormRecognitionResult {
  /**
   *
   * @type {Array<RecognitionAlternative>}
   * @memberof SpokenFormRecognitionResult
   */
  alternatives: Array<RecognitionAlternative>;
  /**
   *
   * @type {number}
   * @memberof SpokenFormRecognitionResult
   */
  end_time: number;
  /**
   *
   * @type {number}
   * @memberof SpokenFormRecognitionResult
   */
  start_time: number;
  /**
   * What kind of object this is. See #/Definitions/RecognitionResult for definitions of the enums.
   * @type {string}
   * @memberof SpokenFormRecognitionResult
   */
  type: SpokenFormRecognitionResultTypeEnum;
}

export const SpokenFormRecognitionResultTypeEnum = {
  Word: 'word',
  Punctuation: 'punctuation',
} as const;

export type SpokenFormRecognitionResultTypeEnum =
  (typeof SpokenFormRecognitionResultTypeEnum)[keyof typeof SpokenFormRecognitionResultTypeEnum];
